import { useContext, useEffect, useState } from 'react';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { SelectRegion } from './selectRegion';
import { ContextApi } from '../../context/contextApi';

import styles from './style.module.scss';

export function FormNewUser() {
  const {
    newUser,
    listAllRegional,
    allRegional
} = useContext(ContextApi);
    const [nameUser, setNameUser] = useState('');
    const [email, setEmail] = useState('');
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [valueProfile, setValueProfile] = useState('regional');
    const [errorInputName, setErrorInputName] = useState(false);
    const [errorInputEmail, setErrorInputEmail] = useState(false);

    const handleChangeProfile = (event) => {
      setValueProfile(event.target.value);
    };

    function handleSubmitNewUser() {
      if (nameUser !== '' && email !== '') {
        newUser({
          name: nameUser,
          role: valueProfile,
          email: email,
          regional_id: right.map(regional => regional?.id)
        })
        setNameUser('')
        setEmail('')
        setRight([])
      } else {
        if (nameUser === '' || !nameUser) {
          setErrorInputName(true);
        } else {
          setErrorInputName(false);
        }
        if (email === '' || !email) {
          setErrorInputEmail(true);
        } else {
          setErrorInputEmail(false);
        }
      }
    }

    useEffect(() => {
      listAllRegional()
    }, [])

    useEffect(() => {
      let reginalMap = []
      allRegional.map(regional => {
        reginalMap.push({
          id: regional.id,
          uf: regional.nome
        })
      })
      setLeft(reginalMap)
    }, [allRegional])
    
    return (
        <div className={styles.containerDadosPrincipais}>
          <div className={styles.boxFormNewUserVidro}>
            <div className={styles.rowNameAndProfile}>
              <div className={styles.inputTextName}>
                  <label>Nome do usuário</label>
                  {errorInputName && <span className={styles.errorInput}>*Campo obrigatório</span>}
                  <input
                  onChange={(e) => setNameUser(e.target.value)}
                  value={nameUser}
                  name='nameUser'
                  />
              </div>
              <FormControl>
                <span className={styles.labelSelectProfile}>Perfil do Usuário</span>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={valueProfile}
                  onChange={handleChangeProfile}
                >
                  <FormControlLabel value="regional" control={<Radio />} label="Regional" />
                  <FormControlLabel value="painel" control={<Radio />} label="ADM" />
                </RadioGroup>
              </FormControl>
            </div>
            <div className={styles.inputText}>
                <label>E-mail</label>
                {errorInputEmail && <span className={styles.errorInput}>*Campo obrigatório</span>}
                <input
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                name='email'
                />
              </div>
              {valueProfile === 'regional' &&
              <SelectRegion 
              left={left}
              setLeft={setLeft}
              right={right}
              setRight={setRight}
              />}
              <div className={styles.boxBTNSubmit}>
                  <span
                  onClick={() => handleSubmitNewUser()}
                  >Criar usuário</span>
              </div>
            </div>
        </div>
    )
}